export function prefixHttp(rule: string) {
  const hasHttp = rule.startsWith("http://") || rule.startsWith("https://");
  if (hasHttp) return rule;
  return `https://${rule}`;
}

const queryParamRegex = /^[^=]+=[^=]+$/;
export function isQueryParam(rule: string) {
  return queryParamRegex.test(rule);
}

export function isUrl(value: string, options?: { ensureProtocol?: boolean }) {
  try {
    const url = new URL(options?.ensureProtocol ? prefixHttp(value) : value);
    return isValidHost(url.host);
  } catch (error) {
    return false;
  }
}

export function isReferringDomain(value: string) {
  try {
    const url = new URL(prefixHttp(value));
    if (url.pathname !== "/" || url.search !== "" || url.hash !== "") {
      return false;
    }
    return isValidHost(url.host);
  } catch (e) {
    return false;
  }
}

export function isValidHost(hostname: string) {
  if (hostname === "localhost" || hostname.startsWith("localhost:")) {
    return true;
  }

  // URL class allows URLs without TLD, we're making sure it's there
  const fragments = hostname.replace(/^www\./i, "").split(".");

  return (
    fragments.length > 1 && fragments.every((fragment) => fragment.length > 0)
  );
}
